<template>
  <ModalComponent class="pt-4" ref="modalRef" />
  <div class="d-flex justify-content-start">
    <h1 class="font-raleway-Light-30 p-2 ps-0 pb-0 mb-0 m-4">Creador de Flotas</h1>
  </div>

  <div class="d-flex justify-content-start">
    <div class="col-lg-3">
      <h1 class="font-raleway-regular-23 ps-0 pt-4 p-2 m-4">Datos de la flota</h1>
    </div>
  </div>
  <div class="ps-4 ms-2 me-4">
    <form @submit.prevent="submitForms">
      <div class="d-flex col-md-10 justify-content-end">
        <div class="form-check font-roboto-regular-12-gray">
          <input type="checkbox" class="form-check-input" id="checkbox" v-model="checkbox">
          <label class="form-check-label pt-1" for="checkbox">Extranjero</label>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="row">
          <div class="col-md-3 p-2">
            <MDBInput label="Nombre Interno" class="active" v-model="data.company.fantasy_name"
              @blur="validateEnterpriseName" />
            <div v-if="!formFleet && !isValidNameFormat" class="text-danger font-roboto-regular-12 ps-3">
              *Carácteres no permitidos(.;\\'\/) ni espacios.
            </div>
          </div>
          <div class="col-md-3 p-2">
            <MDBInput label="Nombre de la empresa" class="active" v-model="data.company.full_name" />
          </div>
          <div class="col-md-3 p-2">
            <MDBInput label="Giro" class="active" v-model="data.company.line_of_business" />
          </div>
          <div class="col-md-3 p-2">
            <MDBInput label="Código" class="active" v-model="data.company.identification_number" v-if="checkbox" />
            <MDBInput label="RUT" class="active" v-model="data.company.identification_number" @blur="validateRutFormat"
              v-if="!checkbox" />
            <div v-if="!formFleet && !isValidRutFormat && !checkbox" class="text-danger font-roboto-regular-12 ps-3">
              RUT erróneo. Ej: 12.345.678-0
            </div>
          </div>
          <div class="col-md-3 p-2">
            <MDBInput label="Teléfono" class="active" v-model="data.company.phone" type="number"
              @blur="validatePhoneFormat" />
            <div v-if="!formFleet && !isValidPhoneFormat" class="text-danger font-roboto-regular-12 ps-3">
              Teléfono erróneo. Ej: +56 9 1234 5678
            </div>
          </div>
          <div class="col-md-3 p-2">
            <div class="max-w-xs">
              <VaSelect class="form-outline custom-border" v-model="data.tmz" :options="options" searchable
                @update:modelValue="getUTC()" highlight-matched-text />
            </div>
            <div class="ms-3">
              Zona horaria: {{ utcOffset }}
            </div>
          </div>
          <div class="col-md-3 p-2">
            <MDBInput label="Calle" class="active" v-model="data.company.address.street" />
          </div>
          <div class="col-md-1 p-2">
            <MDBInput label="Número" class="active" v-model="data.company.address.number" type="number" />
          </div>
          <div class="col-md-1 p-2">
            <MDBInput label="Oficina" class="active" v-model="data.company.address.apartment" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 p-2">
            <MDBInput label="Ciudad" class="active" v-model="data.company.address.city" />
          </div>
          <div class="col-md-2 p-2">
            <MDBInput v-if="!isCountryLength" label="País" class="active" v-model="data.company.address.country" />
            <select v-if="isCountryLength" class="form-select active" v-model="countrySelected"
              @change="selectCountry()">
              <option v-for="countryName in countriesData" :key="countryName" :value="countryName">
                {{ countryName }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="d-flex justify-content-start">
    <div class="col-lg-4">
      <h1 class="font-raleway-regular-23 ps-0 p-2 m-4">Datos de Contacto Administrador</h1>
    </div>
  </div>
  <div class="ps-4 ms-2 me-4">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-md-3 p-2">
          <MDBInput label="Nombre" class="active" v-model="data.contact.name" />
        </div>
        <div class="col-md-3 p-2">
          <MDBInput label="Email" class="active" v-model="data.contact.email" @blur="validateEmailFormat" />
          <div v-if="!formAdmin && !isValidEmailFormat" class="text-danger font-roboto-regular-12 ps-3">
            Ingrese un correo válido
          </div>
        </div>
        <div class="col-md-3 p-2">
          <MDBInput label="Teléfono" class="active" v-model="data.contact.phone_1" type="number"
            @blur="validatePhoneFormat" />
          <div v-if="!formAdmin && !isValidPhoneFormat" class="text-danger font-roboto-regular-12 ps-3">
            Teléfono erróneo. Ej: +56 9 1234 5678
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-start">
    <div class="col-lg-4">
      <h1 class="font-raleway-regular-23 ps-0 p-2 m-4">Datos de Mapa</h1>
    </div>
  </div>
  <div class="ps-4 ms-2 me-4">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-md-3 p-2">
          <MDBInput label="Zoom" class="active" v-model="data.map.zoom" />
        </div>
        <div class="col-md-3 p-2">
          <MDBInput label="Latitud" class="active" v-model="data.map.latitude" />
        </div>
        <div class="col-md-3 p-2">
          <MDBInput label="Longitud" class="active" v-model="data.map.longitude" />
        </div>
      </div>
    </div>
    <div class="pt-4">
      <button type="submit" class="btn btn-outline-success" @click="submitForms">Crear Flota</button>
    </div>
  </div>
</template>
<script>
import ModalComponent from '../utils/modal.vue';
const moment = require('moment-timezone');
const ct = require('countries-and-timezones');

export default {
  name: 'NewFleet',
  components: ModalComponent,

  data() {
    return {
      isCountryLength: false,
      name: '',
      pass: '',
      checkbox: false,
      isValidNameFormat: true,
      isValidRutFormat: true,
      isValidEmailFormat: true,
      isValidPhoneFormat: true,
      formFleet: false,
      formAdmin: false,
      formMap: false,
      options: [],
      utcOffset: '',
      timezonesData: [],
      countriesData: [],
      countrySelected: '',
      data: {
        access: 'FULL',
        plan: 'FULL_3',
        location_mode: 'HIGH',
        state: 'CLIENT',
        timezones: [],
        timezone: 0,
        tmz: '',
        search_country_code: '',
        company: {
          fantasy_name: '',
          full_name: '',
          line_of_business: '',
          identification_number: '',
          phone: '',
          address: {
            street: '',
            number: '',
            apartment: '',
            city: '',
            country: '',
            raw_address: ''
          },
        },
        contact: {
          name: '',
          email: '',
          phone_1: '',
          address: {
            city: '',
            country: '',
            raw_address: ''
          }
        },
        map: {
          zoom: '14',
          longitude: '-70.6305138355587',
          latitude: '-33.43896947945434'
        },
        theme: {
          primary_text_color: "#FFFFFF",
          primary_background_color: '#F9C700',
          secondary_background_color: '#FF8000',
          secondary_text_color: '#FFFFFF'
        }
      },
    };
  },
  mounted() {
    let timezones = ct.getAllTimezones()

    if (timezones && typeof timezones === 'object') {
      this.timezonesData = Object.keys(timezones).map(key => ({
        name: key,
        value: timezones[key].name,
        utc: timezones[key].utcOffsetStr,
        dst: timezones[key].dstOffsetStr,
        countries: timezones[key].countries
      }));

      this.timezonesData.forEach(zone => {
        this.options.push(zone.name);
      });

      this.data.tmz = 'America/Santiago';
      this.getUTC();
      this.selectCountry();
    }
  },
  methods: {
    getUTC() {
      const zone = this.timezonesData.find(zone => zone.name === this.data.tmz);

      const currentDate = moment();
      const isDST = currentDate.tz(zone.name).isDST();
      let offset = isDST ? zone.dst : zone.utc;

      const sign = offset.charAt(0);

      let offsetNumber = parseInt(offset.slice(1).replace(':', ''), 10).toString();
      offsetNumber = offsetNumber.replace(/0/g, '');

      this.utcOffset = sign + offsetNumber;
      this.data.timezones.push({ "timezone": this.utcOffset, "created_at": 0 });

      this.selectCountry()

    },
    selectCountry() {
      const zone = this.timezonesData.find(zone => zone.name === this.data.tmz);
      if (zone) {
        const countries = zone.countries;
        if (countries && countries.length > 0) {
          if (countries.length > 1) {
            this.countrySelected = undefined
            this.isCountryLength = true;
            this.countriesData = countries.map(countryCode => ct.getCountry(countryCode).name);
            if (!this.countrySelected) {
              this.countrySelected = this.countriesData[0];
            }
            let selectedCountry = countries.find(countryCode => ct.getCountry(countryCode).name === this.countrySelected);
            this.data.search_country_code = selectedCountry ? selectedCountry.id : '';
            this.data.company.address.country = this.countrySelected;
          } else {
            this.isCountryLength = false;
            const countryCode = countries[0];
            const countryName = ct.getCountry(countryCode);
            this.countrySelected = countryName.name;
            this.data.search_country_code = countryCode;
            this.data.company.address.country = this.countrySelected;
          }
        }
      }
    },
    validateEmailFormat() {
      if (this.data.contact.email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        this.isValidEmailFormat = emailRegex.test(this.data.contact.email);

        if (!this.isValidEmailFormat) {
          this.formAdmin = false;
        }
      }
    },
    validatePhoneFormat() {
      if (this.data.company.phone || this.data.contact.phone_1) {
        if (this.checkbox) {
          const phoneRegex = /^\+?[1-9]\d{1,14}$/;
          this.isValidCompanyPhone = !!this.data.company.phone && phoneRegex.test(this.data.company.phone);
          this.isValidContactPhone = !!this.data.contact.phone_1 && phoneRegex.test(this.data.contact.phone_1);

          if (this.data.company.phone && !this.isValidCompanyPhone) {
            this.formFleet = false;
          }
          if (this.data.contact.phone_1 && !this.isValidContactPhone) {
            this.formAdmin = false;
          }
        } else {
          const chilePhoneRegex = /^0?\d{9}$/;
          this.isValidCompanyPhone = !!this.data.company.phone && chilePhoneRegex.test(this.data.company.phone);
          this.isValidContactPhone = !!this.data.contact.phone_1 && chilePhoneRegex.test(this.data.contact.phone_1);

          if (this.data.company.phone && !this.isValidCompanyPhone) {
            this.formFleet = false;
          }
          if (this.data.contact.phone_1 && !this.isValidContactPhone) {
            this.formAdmin = false;
          }
        }
      }
    },
    validateEnterpriseName() {
      if (this.data.company.fantasy_name) {
        const nameRegex = /^[a-z][a-z0-9]*$/i;

        this.isValidNameFormat = nameRegex.test(this.data.company.fantasy_name)

        if (!this.isValidNameFormat) {
          this.formFleet = false
        }
      }
    },
    validateRutFormat() {
      if (this.data.company.identification_number) {
        const rutRegex = /^([1-9]|[1-9]\d|[1-9]\d{2})((\.\d{3})*|(\d{3})*)-(\d|k|K)$/;

        this.isValidRutFormat = rutRegex.test(this.data.company.identification_number.toString());

        if (!this.isValidRutFormat) {
          this.formFleet = false;
        }
      }
    },
    sendDataFleet() {

      this.formFleet = true;

      for (const key in this.data.company) {
        if (Object.hasOwnProperty.call(this.data.company, key)) {
          const value = this.data.company[key];

          if (!value) {
            this.formFleet = false;
            break;
          }
        }
      }
    },

    sendDataAdmin() {
      this.formAdmin = true;

      for (const key in this.data.contact) {
        if (Object.hasOwnProperty.call(this.data.contact, key)) {
          const value = this.data.contact[key];

          if (!value) {
            if (this.data.contact.city === '' || this.data.contact.country === '' || this.data.contact.raw_address === '') {
              this.formAdmin = true
            } else this.formAdmin = false;

            break;
          }
        }
      }
    },

    sendMapData() {
      this.formMap = true;

      for (const key in this.data.map) {
        if (Object.hasOwnProperty.call(this.data.map, key)) {
          const value = this.data.map[key];

          if (!value) {
            this.formMap = false;
            break;
          }
        }
      }
    },

    submitForms() {
      this.sendDataFleet();
      this.sendDataAdmin();
      this.sendMapData();

      this.data.long_retrieve_enabled = true;
      this.data.use_new_web = true
      this.getUTC()


      if (this.formFleet && this.formAdmin && this.formMap) {
        this.$refs.modalRef.updateTitle('Confirmación de Creación de Flota');
        this.$refs.modalRef.updateContent('', true);
        this.$refs.modalRef.openModal();

        this.data.timezone = this.utcOffset
        const dataString = JSON.stringify(this.data);
        localStorage.setItem('data', dataString);
      } else {
        this.$refs.modalRef.updateTitle('Cuidado');
        this.$refs.modalRef.updateContent('Debe rellenar todo el formulario', false);
        this.$refs.modalRef.openModal();
      }
    }

  },
};
</script>

<style>
.form-select {
  color: rgba(0, 0, 0, .6);
}

.btn-outline-success {
  text-transform: inherit !important;
}

.modal-dialog {
  margin-top: 158px !important;
}

/* Oculta las flechas de los controles de número en form-control */
.form-control[type="number"]::-webkit-inner-spin-button,
.form-control[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.form-control[type="number"] {
  -moz-appearance: textfield;
}

.custom-border {
  border: 1px solid #e5e4e4;
  /* Ajusta el grosor y el color del borde según sea necesario */
  border-radius: 5px;
  /* Opcional: agrega esquinas redondeadas */
}
</style>